import React from "react"
import styles from './manual-mark-icon.module.css';
import { useNavigate } from "react-router-dom"

type Props = {}

export const ManualMarkIcon = (props: Props) => {

  const navigate = useNavigate();

  const naviageToMaualMark = ()=>{
    navigate("/manualMark");
  }

  return (
    <div className={"cursor-pointer " + styles.menuItem} onClick={naviageToMaualMark}>
      <div className={"d-flex justify-content-center mt-3"}>
        <i className="fas fa-file-signature font-size-20"></i>
      </div>
      <div className={"d-flex justify-content-center font-size-12"}>
        Evaluations
      </div>
    </div>
  )
}